window.$ = window.jQuery = require('jquery');
require('@popperjs/core');
require('bootstrap/dist/js/bootstrap.min');

window.VGNav = require('vgnav/dist/js/vgnav');
window.Cookie = require('js-cookie/src/js.cookie');
window.select2 = require('../../vendor/select2/select2.min');
require('../../vendor/select2/i18n/ru')
require('vgformsender/dist/js/vgformsender.min');
//require('vgscrollto/dist/js/vegascrollto');
require('vgsidebar/dist/js/vgsidebar');

require('@fancyapps/fancybox/dist/jquery.fancybox');
//require('jquery-nice-select/js/jquery.nice-select.min');
require('inputmask/dist/inputmask');
require('jquery-toast-plugin/dist/jquery.toast.min');
require('ion-rangeslider/js/ion.rangeSlider');

require('../../vendor/plugins/parallax/parallax.min');
require('../../vendor/plugins/dropdown/jquery.vegasDropdown');
require('../../vendor/plugins/sumoselect/jquery.sumoselect');

require('../../vendor/modules/bg');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');
require('../../vendor/modules/carousel');

require('./modules/shop/product');
require('./modules/shop/discount');
require('./modules/shop/cart');
require('./modules/shop/price');
require('./modules/shop/additional');
require('./modules/shop/order');
require('./modules/shop/catalog');
require('./modules/input-counter');
require('./modules/form-loader');
require('./modules/trigger-form');
require('./modules/search');
require('./modules/city');
require('./modules/account/account');

require('./modules/vegas');
require('./modules/parallax');
require('./modules/ym');
require('./functions');

require('./modules/auth');
// [[vegas]]
require('./custom');